import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
let QuizQuestionCorrectionExplanation = class QuizQuestionCorrectionExplanation extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "questionCorrection", void 0);
  }
};
__decorate([Prop({
  required: true
})], QuizQuestionCorrectionExplanation.prototype, "questionCorrection", void 0);
QuizQuestionCorrectionExplanation = __decorate([Component], QuizQuestionCorrectionExplanation);
export default QuizQuestionCorrectionExplanation;